import { createAction, props } from '@ngrx/store';
import { DocTitlebar } from 'src/app/core/models/app-state.models';


export const setTitlebarTitle = createAction(
    '[App] Changed title bar title',
    props<{ title: string | null }>()
)

export const setTitlebarNotification = createAction(
    '[App] Changed title bar notification status',
    props<{ status: boolean }>()
)

export const setTitlebarBackNav = createAction(
    '[App] Changed title bar back navigation button status',
    props<{ status: boolean }>()
)

export const resetTitlebar = createAction(
    '[App] Resetting titlebar configuration'
)

export const setTitlebar = createAction(
    '[App] Title bar configuration changed',
    props<DocTitlebar>()
)